import { useState, SyntheticEvent } from 'react';
import { Box, Paper, Tab, Tabs } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Link, Outlet } from 'react-router-dom';
import { PageHeader } from '../../components/PageHeader';
import { PageLayout } from '../../layout';

export const ContactsPage = () => {
  const { t } = useTranslation();

  const [value, setValue] = useState(0);
  const handleChange = (event: SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  return (
    <PageLayout>
      <PageHeader title={t('contacts')} backRouteTo={null} />

      <Paper sx={{ mt: 4, overflow: 'hidden', flexShrink: 0 }}>
        <Tabs variant="fullWidth" value={value} onChange={handleChange} aria-label="customers and vendors navigation">
          <Tab component={Link} label={t('customers')} to="customers" role={'navigation'} tabIndex={0} />
          <Tab component={Link} label={t('vendors')} to="vendors" role={'navigation'} tabIndex={0} />
        </Tabs>
      </Paper>

      <Box py={4}>
        <Outlet />
      </Box>
    </PageLayout>
  );
};
